const config = {
  API_BASE_URL: "https://www.agileseekers.com/ag_admin/api",
  BASE_URL: "https://www.agileseekers.com",
};
export default config;

// const config = {
//     API_BASE_URL: "https://agileseeker.jdinfotech.net/api",
//     BASE_URL: "https://agiledevelopment.jdinfotech.net",
// };
// export default config;
